export default __webpack_public_path__ + "static/media/thumb_east_douglas.8e42dfbd.jpg";